module.exports = __webpack_public_path__ + "AvertaStd-Semibold.svg?043e768dacd8259dc14142bc4a341ae5";